// Page Load Transition Event
export const LOAD_DATA_TRANSITION_FUND_DATA = 'taxFreeSavingsAccount/fundData/transition/fundDataLoad';
export const loadFundData = () => ({ type: LOAD_DATA_TRANSITION_FUND_DATA });

// Event
export const SET_VALUE_FUND_DATA = 'taxFreeSavingsAccount/fundData/setValue/fundData';
export const setFundData = value => ({ type: SET_VALUE_FUND_DATA, value });
